import React from 'react';
import PickMeals from "../Assets/izzy-boscawen-HrcpO5MCedQ-unsplash.jpg";
import ChooseMeals from "../Assets/ella-olsson-4dQiaWKiL-Y-unsplash.jpg";
import DeliveryMeals from "../Assets/freddy-g-6eAfaHjqThk-unsplash.jpg";

function Work() {
    const workInfoData = [
        {
            image: PickMeals,
            title: "Bolognese Wagyu",
            text: "Bolognese Wagyu is een heerlijk gerecht dat je smaakpapillen zal verrassen. Dit gerecht is bereid met de simpelste ingrediënten",
        },
        {
            image: ChooseMeals,
            title: "Aardappel Schotel",
            text: "De aardappelschotel is een heerlijk gerecht voor de hele familie.",
        },
        {
            image: DeliveryMeals,
            title: "Pizza Calzone",
            text: "De Pizza Calzone, maar dan in een luxe jasje.",
        },
    ];
    return (
        <div className='work-section-wrapper'>
            <div className='work-section-top'>
                <p className='primary-subheading'>Highlight</p>
                <h1 className='primary-heading'>Recepten van de Week</h1>
                <p className='primary-text'>
                    Ontdek onze topgerechten van de week, bereid door onze topchefs. Geniet van een culinaire ervaring bij jou thuis.
                </p>
            </div>
            <div className='work-section-bottom'>
                {workInfoData.map((data) => (
                    <div className='work-section-info' key={data.title}>
                        <div className='info-boxes-img-container'>
                            <img src={data.image} alt={data.title} />
                        </div>
                        <h2>{data.title}</h2>
                        <p>{data.text}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Work;